<div class="modal-header"> <h3>Select a profile picture</h3> </div> <div class="modal-body" stopEvent="touchend"> <img-cropper [image]="selectedImage" [settings]="cropperSettings"></img-cropper> </div> <div class="modal-footer"> <button class="btn btn-default" (click)="cancel()">Cancel</button> <button class="btn btn-default" (click)="ok()">OK</button> </div>


// WEBPACK FOOTER //
// ng:///builds/lyonzy/shelvable/web/static/components/image-crop/image-crop.html